import React from "react";
import { Box, Tooltip } from "@mui/material";

const TruncatedCellText = ({ value, fallback = "—", maxWidth = 240 }) => {
  const text = value || fallback;
  const title = text === fallback ? "" : text;

  return (
    <Tooltip title={title} arrow enterDelay={500}>
      <Box
        component="span"
        sx={{
          display: "block",
          maxWidth,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {text}
      </Box>
    </Tooltip>
  );
};

export default TruncatedCellText;
